module.exports = __webpack_public_path__ + "static/media/micro.05be415d.png";